import { CUKCUK_MAX_FILE_SIZE_BYTES } from '../constants/cukcuk';
import { isCukcukInvoiceFile } from './cukcukInvoiceImportUtils';
import { isCukcukMenuFile } from './cukcukParser';

export type CukcukFileKind = 'menu' | 'invoice';

export interface CukcukFileValidationResult {
  valid: boolean;
  error?: string;
}

const hasExcelExtension = (fileName: string): boolean =>
  /\.(xls|xlsx)$/i.test(fileName.trim());

export const validateCukcukUploadFile = (file: File, kind: CukcukFileKind): CukcukFileValidationResult => {
  if (!hasExcelExtension(file.name)) {
    return {
      valid: false,
      error: 'Chỉ hỗ trợ file Excel .xls hoặc .xlsx.',
    };
  }

  if (file.size > CUKCUK_MAX_FILE_SIZE_BYTES) {
    return {
      valid: false,
      error: `File vượt quá ${Math.round(CUKCUK_MAX_FILE_SIZE_BYTES / (1024 * 1024))}MB.`,
    };
  }

  if (file.size === 0) {
    return {
      valid: false,
      error: 'File rỗng — vui lòng chọn file export từ CUKCUK.',
    };
  }

  return { valid: true };
};

export const assertCukcukFileKind = async (
  file: File,
  kind: CukcukFileKind,
): Promise<CukcukFileValidationResult> => {
  const base = validateCukcukUploadFile(file, kind);
  if (!base.valid) return base;

  const isValid =
    kind === 'menu' ? await isCukcukMenuFile(file) : await isCukcukInvoiceFile(file);

  if (!isValid) {
    return {
      valid: false,
      error:
        kind === 'menu'
          ? 'File không phải export DANHMUCTHUCDON từ CUKCUK (thiếu sheet Thực đơn hoặc header không khớp).'
          : 'File không phải export Chi tiết doanh thu từ CUKCUK (header không khớp).',
    };
  }

  return { valid: true };
};